import useDetectMobile from "hooks/useDetectMobile";

type DesktopViewProps = {
  children: React.ReactNode;
};

const DesktopView = ({ children }: DesktopViewProps) => {
  const isMobile = useDetectMobile();
  if (isMobile) {
    return null;
  }
  // This component is used in the desktop view of the app

  return children;
};

export default DesktopView;
